module.exports = __webpack_public_path__ + "static/media/icon-gear.2d44826e.svg";